import { LocaleProvider } from '@chakra-ui/react';
import { useI18nStore } from '@/store/i18n/store';

export interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const language = useI18nStore((state) => state.language);
  return <LocaleProvider locale={language}>{children}</LocaleProvider>;
}
